<template>
  <div>
    <div class="head-box">
      <div class="c-flex c_flex_center">
        <h4>门店码管理（高级版）</h4>
      </div>
      <div class="c-flex c-flex-item">
        <el-input
          placeholder="请输入伙伴名称/电话"
          v-model="searchValue"
          clearables
          style="width: 270px"
          @clear="
            fpi.page = 1;
            getData();
          "
          @keyup.enter.native="
            fpi.page = 1;
            getData();
          "
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="
              fpi.page = 1;
              getData();
            "
          ></el-button>
        </el-input>
        <!-- <el-button type="primary" @click="doNew" class="c-m-l-10">新增伙伴</el-button> -->
        <!-- <el-button
          type="primary"
          class="c-m-l-10"
          @click="
            osg.doExport({
              'fpi-regex:name|string#or': searchValue,
              'fpi-regex:phone|string#or': searchValue,
              'fpi-regex:_id|string#or': searchValue,
              beanName: 'partner',
              title: '伙伴列表'
            })
          "
        >
          数据导出
        </el-button> -->
        <el-popover width="200" popper-class="c-popper" @show="osg.colSetShow">
          <div
            v-if="osg.customize.entity.entityID == osg.customize.entity.tenantId"
            style="border-bottom: 1px solid #DCDFE6;margin-bottom: 12px;"
          >
            <div>
              <i class="el-icon-s-tools c-m-r-5"></i>
              <span>应用范围：</span>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-model="osg.customize.bizType"
                @change="osg.customizeBizTypeChange"
                placeholder="请选择 个人/组织/角色"
                size="small"
                style="width:100%"
              >
                <el-option
                  v-for="item in osg.options.bizType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-if="osg.customize.bizType == 0"
                v-model="osg.customize.bizId"
                :remote-method="osg.getUsers"
                filterable
                remote
                placeholder="可搜索人员姓名/手机/组织"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.users"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
              <el-cascader
                v-if="osg.customize.bizType == 1"
                v-model="osg.customize.bizId"
                :options="osg.options.orgs"
                :props="{
                  checkStrictly: true,
                  emitPath: false,
                  label: 'orgName',
                  value: '_id',
                  children: 'orgList'
                }"
                size="small"
                style="width:100%"
                placeholder="请选择组织"
              ></el-cascader>
              <el-select
                v-if="osg.customize.bizType == 2"
                v-model="osg.customize.bizId"
                placeholder="请选择角色"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.roles"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="c-popper-header">
            <i class="el-icon-info c-blue c-m-r-5"></i>
            <span>拖拽字段进行排序</span>
          </div>
          <div class="c-popper-content">
            <draggable v-model="extFields" @end="osg.listRefresh">
              <transition-group>
                <template v-for="(f, i) in extFields">
                  <div
                    v-if="f.showList && f.showList.indexOf('1') != -1"
                    :key="i"
                    class="c-popper-row"
                  >
                    <el-switch
                      v-model="f.customizeFlag"
                      :active-value="1"
                      :inactive-value="0"
                      @change="osg.listRefresh"
                    ></el-switch>
                    <span>{{ f.nameDisp }}</span>
                  </div>
                </template>
              </transition-group>
            </draggable>
          </div>
          <div class="c-popper-footer">
            <el-button type="primary" size="mini" @click="osg.saveConfig()">保存</el-button>
            <el-button type="text" size="mini" @click="osg.listReset">重置</el-button>
          </div>
          <i slot="reference" class="el-icon-s-operation c_size_20 c-blue c-m-l-10 c-pointer"></i>
        </el-popover>
      </div>
    </div>
    <div class="content-box">
      <!-- <div class="content-filter">
        <c-filter></c-filter>
      </div> -->
      <div class="content-table">
        <el-table
          ref="table"
          height="calc(100% - 50px)"
          :data="fpi.data"
          v-if="refresh && extFields.length"
          highlight-current-row
          border
          @header-dragend="osg.colWidthChange"
        >
          <el-table-column fixed="right" width="100px">
            <template slot-scope="scope">
              <el-dropdown>
                <el-button>
                  操作
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="viewQR($event, scope.row._id)">
                    查看门店码
                  </el-dropdown-item>
                  <el-dropdown-item @click.native="doSetting($event, scope.row._id)">
                    门店设置
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
          <c-table :fields="extFields" :options="options"></c-table>
          <el-table-column width="240px" prop="orgName" label="所属部门"></el-table-column>
        </el-table>
        <el-pagination
          class="pagination"
          @size-change="pageSizeChange"
          @current-change="pageChange"
          :current-page="fpi.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="fpi.rows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="fpi.total"
        ></el-pagination>
      </div>
    </div>
    <el-dialog
      title="门店码"
      :visible.sync="openQRDetail"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :destroy-on-close="true"
    >
      <div style="display: flex; align-items: center">
        分享二维码：
        <div class="qrcode" style="margin: 20px 0 0 10px" ref="qrCodeUrl"></div>
      </div>
      <div style="margin-top: 26px">
        <span>分享长链接：</span>
        <el-link :href="href" target="_blank">{{ `${href}` }}</el-link>
      </div>
      <div slot="footer" style="display: flex; justify-content: space-between">
        <span></span>
        <el-button type="primary" @click="openQRDetail = false">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="门店信息"
      :visible.sync="openPartnerDetail"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <c-form
        :formData="partnerFormData"
        :fields="extFields"
        :options="options"
        ref="form"
        :upload="upload"
        labelWidth="160px"
        :area="area"
        @changeForm="osg.changeForm"
      >
        <template slot="address">
          <el-input
            v-model="partnerFormData.address"
            @blur="getGeocode(partnerFormData.address)"
          ></el-input>
        </template>
        <template slot="gpsPoint.longitude">
          <el-input
            v-model="partnerFormData.gpsPoint.longitude"
            disabled
            placeholder="根据地址自动生成"
          ></el-input>
        </template>
        <template slot="gpsPoint.latitude">
          <el-input
            v-model="partnerFormData.gpsPoint.latitude"
            disabled
            placeholder="根据地址自动生成"
          ></el-input>
        </template>
      </c-form>
      <div slot="footer">
        <el-button type="primary" @click="doSavePartner">确 定</el-button>
        <el-button
          @click="
            openPartnerDetail = false;
            partnerFormData = { gpsPoint: {}, exts: {} };
          "
        >
          取 消
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import QRCode from 'qrcodejs2';
// import areajs from '../../resources/js/area.js';
export default {
  activated() {
    window.$this = this;
  },
  name: 'partner',
  data() {
    return {
      tenantId: '',
      name: 'partner',
      refresh: true,
      fpi: {},
      searchValue: '',
      openDetail: false,
      formData: {},
      partnerFormData: { gpsPoint: {}, exts: {} }, //伙伴表单
      extFields: [],
      extField: {}, //特殊字段类型 如rate值为number类型,checkbox值为数组不能为空
      rules: this.$util.rules,
      options: {
        codecfg_partnerType: { codeId: 'partnerType' },
        codecfg_industry: { codeId: 'INDUSTRY' }
      },
      contactList: [],
      //全部组织
      treeDataOptions: [],
      isEdit: false,
      baseUrl: '', //二维码基础路径
      openQRDetail: false, //二维码弹窗
      openPartnerDetail: false, //伙伴表单弹窗
      href: '', //二维码路径
      upload: {
        url: 'http://up-z1.qiniup.com',
        downloadUrl: this.osg.downloadUrl,
        data: {},
        dialogImageUrl: '',
        dialogVisible: false
      },
      //地址
      area: {
        options: this.osg.areaList,
        props: {
          checkStrictly: true,
          expandTrigger: 'hover'
        }
      },
      partnerId: '' //伙伴id
    };
  },
  beforeCreate() {
    window.$this = this;
  },
  async mounted() {
    this.doInit();

    let acount = JSON.parse(sessionStorage['loginAccount']);
    this.tenantId = acount.tenantId;
    this.queryLocationHost();
    // await this.queryPartnerId();
    this.getInit();
  },
  methods: {
    getInit() {
      this.osg.ajax(
        'biz/extField/query.do',
        {
          colName: 'partner',
          _all: '1',
          'is:state|integer#and': 1,
          sortField: 'order',
          sortOrder: 'asc'
        },
        res => {
          this.options = this.options || [];
          //扩展字段选项关联字典表的查询出选项数据
          for (var item of res.data) {
            //解析字段配置
            if (this.$util.isJson(item.frontEndConfig)) {
              item.frontEndConfig = JSON.parse(item.frontEndConfig);
            } else {
              item.frontEndConfig = {};
            }

            if (item.valueOption) {
              this.options['codecfg_' + item.valueOption] = {
                codeId: item.valueOption
              };
            }
            //级联
            if (item.type == 'cascade')
              this.options['cascadeCode_' + item.valueOption] = {
                codeId: item.valueOption
              };
          }
          this.extFields = res.data.filter(item => {
            return item.frontEndConfig.setting;
          });
          this.osg.codeoption(() => {
            this.osg.getFpi();
            this.getData();
          });
        },
        { noload: true }
      );
    },
    format(option, value) {
      return this.osg.codelabel(option, value);
    },
    formatArray(option, value) {
      return this.osg.codelabelForArray(option, value);
    },
    formatState(row, column, cellValue, index) {
      if (cellValue == 0) return '无效';
      else if (cellValue == 1) return '有效';
      else return '未知';
    },
    formatterIndustry(row, column, cellValue, index) {
      return this.osg.codelabel('industry', cellValue);
    },
    formatterType(row, column, cellValue, index) {
      return this.osg.codelabel('partnerType', cellValue);
    },
    formatterOwner(row, column, cellValue, index) {
      let label = this.contactList
        .map(item => {
          if (item.value == cellValue) {
            return item.label;
          }
        })
        .join('');
      if (label) {
        return label;
      } else {
        return cellValue;
      }
    },
    // formatterDepartment(row, column, cellValue, index) {
    //   return this.treeDataOptions
    //     .map(item => {
    //       // console.log(item._id, cellValue);
    //       if (item._id == cellValue) {
    //         return item.orgName;
    //       }
    //     })
    //     .join("");
    // },
    pageSizeChange(pageSize) {
      this.fpi.rows = pageSize;
      this.getData();
    },
    pageChange(currentPage) {
      this.fpi.page = currentPage;
      this.getData();
    },
    doInit() {
      this.openDetail = false;
      this.openQRDetail = false;
      this.formData = { exts: {} };
      this.partnerFormData = { gpsPoint: {}, exts: {} };
      if (this.$refs.formData) this.$refs.formData.resetFields();
      this.$util.renderExtField(this.extFields, this.formData);
    },
    getData() {
      var params = {
        page: this.fpi.page || 1,
        rows: this.fpi.rows || 20,
        'regex:name|string#or': this.searchValue,
        'regex:phone|string#or': this.searchValue,
        // 'is:_id|string#or': this.partnerId,
        // 'is:parentPartnerId|string#or': this.partnerId,
        'in:partnerType|array-integer#and': '2,3',
        'in:state|integer#and': '1',
        sortField: 'createTime',
        sortOrder: 'desc'
      };
      //添加过滤器参数
      //   $that.getParams(params);
      this.osg.setFpi(params);
      this.osg.ajax('basic/partner/query.do', params, res => {
        this.fpi = res;
        this.$nextTick(() => {
          this.$refs.table.doLayout();
          this.$forceUpdate();
        });
        // this.getContact();
        // this.getOrg();
      });
    },
    getContact() {
      var params = {
        page: this.fpi.page || 1,
        rows: this.fpi.rows || 50,
        sortField: 'createTime',
        sortOrder: 'desc'
      };

      this.osg.ajax(
        'basic/contacts/query.do',
        params,
        res => {
          res.data.map(item => {
            item.label = item.name;
            item.value = item._id;
          });
          this.contactList = res.data;
          this.$forceUpdate();
        },
        { noload: true }
      );
    },
    //根据网址 提示域名下拉框
    querySearch(queryString, cb) {
      let url = this.formData.website;
      let reg = /^((https|http|ftp|rtsp|mms){0,1}(:\/\/){0,1})www\.(([A-Za-z0-9-~]+)\.)+([A-Za-z0-9-~\/])+$/;
      if (reg.test(url)) {
        if (url.indexOf('www.') != -1) {
          url = url.substr(url.indexOf('.') + 1);
        } else if (url.indexOf('http://') != -1) {
          url = url.substr(url.indexOf('/', url.indexOf('/') + 1) + 1);
        } else if (url.indexOf('https://') != -1) {
          url = url.substr(url.indexOf('/', url.indexOf('/') + 1) + 1);
          if (url.indexOf('https://www.') != -1) {
            url = url.substr(url.indexOf('.') + 1);
          }
        }
        // 调用 callback 返回建议列表的数据
        cb([{ label: url, value: url }]);
      } else {
        cb([{}]);
      }
    },
    doNew() {
      this.doInit();
      this.openDetail = true;
      this.isEdit = false;
    },
    doEdit(row) {
      this.isEdit = true;
      var row = this.$util.deepCopy(row);
      this.getContact();
      row.description = [row.description];
      if (row.exts) {
        for (let key in row.exts) {
          if (this.$util.isJson(row.exts[key])) {
            row.exts[key] = JSON.parse(row.exts[key]);
          }
        }
      }
      // //将多选的下拉存成JSON字符串
      // for (let item of this.extFields) {
      //   if (item.type == 'select' && Array.isArray(params.exts[item.name])) {
      //     params.exts[item.name] = JSON.stringify(params.exts[item.name]);
      //   }
      // }
      this.$util.renderExtField(this.extFields, row);
      this.formData = row;
      this.openDetail = true;
    },
    //保存伙伴
    doSavePartner() {
      if (this.osg.validate('partnerFormData')) {
        this.$util.saveFormatExtField(this.extFields, this.partnerFormData);

        //修改伙伴 赋值省市区
        this.partnerFormData.area = this.partnerFormData.area || [];
        if (this.partnerFormData.area.length > 0) {
          this.partnerFormData.province = this.partnerFormData.area[0] || '';
          if (this.partnerFormData.area.length > 1) {
            this.partnerFormData.city = this.partnerFormData.area[1] || '';
            if (this.partnerFormData.area.length > 2) {
              this.partnerFormData.district = this.partnerFormData.area[2] || '';
              if (this.partnerFormData.area.length > 3) {
                this.partnerFormData.subdistrict = this.partnerFormData.area[3] || '';
              }
            }
          }
        }
        this.osg.ajax(
          'basic/partner/upsert.do',
          { partnerStr: JSON.stringify(this.partnerFormData) },
          res => {
            this.osg.ajax(
              'basic/partner/updateOrgName.do',
              {
                partnerName: res.data.name,
                orgId: res.data.orgId
              },
              res => {
                this.openPartnerDetail = false;
                this.partnerFormData = { gpsPoint: {}, exts: {} };
                this.getData();
                this.osg.toast('保存成功！');
              }
            );
          }
        );
      }
    },
    doSave() {
      if (this.osg.validate()) {
        let params = this.$util.deepCopy(this.formData);
        params.description = params.description && String(params.description);
        // extField.type == 'select'
        //将多选的下拉存成JSON字符串
        // for (let item of this.extFields) {
        //   if (item.type == 'select' && Array.isArray(params.exts[item.name])) {
        //     params.exts[item.name] = JSON.stringify(params.exts[item.name]);
        //   }
        // }
        this.$util.saveFormatExtField(this.extFields, params);

        this.osg.ajax('basic/partner/upsert.do', { partnerStr: JSON.stringify(params) }, res => {
          this.osg.ajax(
            'basic/partner/updateOrgName.do',
            {
              partnerName: res.data.name,
              orgId: res.data.orgId
            },
            res => {}
          );
          this.doInit();
          this.getData();
          this.osg.toast('保存成功！');
        });
      }
    },
    doEnable(id) {
      this.osg.ajax('basic/partner/enable/' + id + '.do', null, res => {
        this.getData();
        this.osg.toast('操作成功！');
      });
    },
    doDisable(id) {
      this.osg.ajax('basic/partner/disable/' + id + '.do', null, res => {
        this.getData();
        this.osg.toast('操作成功！');
      });
    },
    //获取组织
    getOrg() {
      return new Promise(resolve => {
        this.osg.ajax('org/query.do', {}, res => {
          if (res.data) {
            let data = [res.data];
            this.treeData = data;
            this.treeDataOptions = this.removeEmpty(
              res.data && res.data.orgList ? res.data.orgList : []
            );
            // this.formData.description = !res.data._id ? "" : res.data._id;
            resolve();
          }
        });
      });
    },
    queryServiceResources(orgId) {
      return new Promise(resolve => {
        this.osg.ajax(
          'biz/serviceResource/query.do',
          {
            'all:serviceCrewId|string#and': orgId,
            sortField: 'createTime',
            sortOrder: 'desc'
          },
          res => {
            // console.log();
            if (res.data) {
              resolve(!res.data.length ? false : res.data[0]._id);
            }
          }
        );
      });
    },
    doRemove(orgId) {
      this.osg.confirm('是否确认删除？', () => {
        let that = this;
        that.queryServiceResources(orgId).then(removeResourcesId => {
          let p1 = function() {
            return new Promise(resolve => {
              that.osg.ajax(`basic/partner/remove/${orgId}.do`, null, res => {
                resolve();
              });
            });
          };
          // let p2 = function() {
          //   return new Promise(resolve => {
          //     that.osg.ajax(
          //       `biz/serviceResource/remove/${removeResourcesId}.do`,
          //       null,
          //       res => {
          //         resolve();
          //       }
          //     );
          //   });
          // };
          // if (removeResourcesId) {
          //   Promise.all([p1(), p2()]).then(() => {
          //     that.osg.toast("删除成功");
          //     that.getData();
          //   });
          // } else {
          p1().then(() => {
            that.osg.toast('删除成功');
            that.getData();
          });
          // }
        });
      });
    },
    //基础（前缀）路径
    queryLocationHost() {
      this.osg.ajax(
        'config/queryLocationHost.do',
        {},
        res => {
          this.baseUrl = res.data;
        },
        { noload: true }
      );
    },
    //查看二维码
    viewQR(e, partnerId) {
      this.href = `${this.baseUrl}tg/?type=tg&partnerId=${partnerId}`;
      this.openQRDetail = true;
      this.$nextTick(() => {
        this.bindQRCode();
      });
    },
    //门店设置
    doSetting(e, partnerId) {
      if (!partnerId) {
        this.osg.toast('当前登陆用户没有所在的服务商！', 'warning');
        return;
      }
      this.osg.ajax(`basic/partner/queryById/${partnerId}.do`, {}, res => {
        this.$util.renderExtField(this.extFields, res);
        res.gpsPoint = res.gpsPoint || {};
        this.partnerFormData = res;
      });

      this.openPartnerDetail = true;
    },
    // //获取partnerId
    // queryPartnerId() {
    //   return new Promise(resolve => {
    //     this.osg.ajax(
    //       'basic/partner/queryPartnerId.do',
    //       {},
    //       res => {
    //         this.partnerId = res.data;
    //         resolve();
    //       },
    //       { noload: true }
    //     );
    //   });
    // },
    //生成二维码
    bindQRCode() {
      new QRCode(this.$refs.qrCodeUrl, {
        text: `${this.href}`,
        width: 200,
        height: 200,
        colorDark: '#333333', //二维码颜色
        colorLight: '#ffffff', //二维码背景色
        correctLevel: QRCode.CorrectLevel.L //容错率，L/M/H
      });
    },
    //删除空数组并且扁平化
    removeEmpty(arr) {
      if (Array.isArray(arr)) {
        arr.forEach(item => {
          if (item.orgList ? item.orgList.length === 0 : false) {
            delete item.orgList;
          } else {
            this.removeEmpty(item.orgList);
          }
        });
        return arr;
      }
    },
    formatterCodelabel(cellValue, valueOption) {
      if (valueOption) {
        return this.osg.codelabel(valueOption, cellValue);
      } else {
        return cellValue;
      }
    },
    renderCompute(formula) {
      return eval(formula);
    },
    //获取地理编码
    async getGeocode(address) {
      if (!address) {
        this.partnerFormData.gpsPoint = {};
        this.partnerFormData.exts.citycode = '';
        this.partnerFormData.exts.address = '';
        return;
      }
      let str = '';
      if (this.$refs.form.$refs.area && this.$refs.form.$refs.area[0].getCheckedNodes()[0]) {
        let arr = this.$refs.form.$refs.area[0].getCheckedNodes()[0].pathLabels;
        if (arr && arr.constructor == Array) {
          for (let item of arr) {
            str += item;
          }
        }
      }
      this.partnerFormData.exts.address = str + address;
      this.osg.geocode(str + address, res => {
        if (!res) {
          this.partnerFormData.gpsPoint = {};
          this.partnerFormData.exts.citycode = '';
          return;
        }
        this.partnerFormData.gpsPoint = {
          longitude: res.location.split(',')[0],
          latitude: res.location.split(',')[1]
        };
        this.partnerFormData.exts.citycode = res.citycode;
        this.$forceUpdate();
      });
    }
  }
};
</script>
<style scoped>
/**/
.content-table >>> .el-cascader.el-cascader--small {
  pointer-events: none;
}
.content-table >>> .el-cascader .el-input .el-input__inner {
  border: 0;
}
.content-table >>> .el-input__suffix {
  right: 5px;
  transition: all 0.3s;
  display: none;
}
.content-table >>> .el-input__inner {
  background: transparent;
}
</style>
